import script from "./LegalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalModal.vue?vue&type=script&setup=true&lang=js"

import "./LegalModal.vue?vue&type=style&index=0&id=ee805e60&scoped=true&lang=css"
import "./LegalModal.vue?vue&type=style&index=1&id=ee805e60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee805e60"]])

export default __exports__